export default {"src":"/_next/static/media/Right Illustration.eda542cd.svg","height":814,"width":1168,"blurWidth":0,"blurHeight":0};